export const example = {
    register:"Register",
    signin:"Sign In",
    home: "Home"
}
